import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class ProgressBar extends Component {
  render() {
    const { max, current, override } = this.props;

    let progress = 0;
    if (max && current) {
      progress = (Number(current) / Number(max)) * 100;
    }
    if (override) {
      progress = override;
    }

    return (
      <div className="progress-con">
        <div className="progress-bar">
          <div className="progress" style={{ width: progress + '%' }}>
            <div className="glow" />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ProgressBar);
